import { css } from '@emotion/react';
import { Theme } from '@mui/material';

export const styles = {
  container: (theme: Theme) => css`
    height: calc(100dvh - 56px);
    display: flex;
    flex-direction: column;
    border-radius: 0;
  `,
  mapContainer: css`
    flex-grow: 1;
  `,
  mapLoadingOverlayWrapper: css`
    position: relative;
    height: 100%;
  `,
  mapOptionBtn: css`
    align-self: flex-end;
  `
};
